import React from "react";
// Components
import Home from "./components/Home";
// Styles
import { GlobalStyle } from "./GlobalStyle";

const App: React.FC = () => {
return (
        <>
            <Home />
            <GlobalStyle />
        </>
    );
}
export default App;
